// React
import { FunctionComponent } from "react";
// Components
import PolusPage from "../../components/PolusPage/PolusPage";
// Styles
import styles from "./InProgress.module.css";
// Fhir front library
import { Title } from "@fyrstain/fhir-front-library";
// Translation
import i18n from "i18next";

const InProgress: FunctionComponent = () => {

  //////////////////////////////
  //          Content         //
  //////////////////////////////
  
  return (
    <PolusPage loading={false} needsLogin={false}>
      <div className={styles.mainErrorContainer}>
        <img
          className={styles.imageIcon}
          src={(process.env.PUBLIC_URL ?? '') + "/assets/InProgress.png"}
          alt="Oops !"
        />
        <Title
          level={1}
          prefix={i18n.t("title.inprogress.wip")}
          content={i18n.t("title.inprogress.comingsoon")}
        />
      </div>
    </PolusPage>
  );
};

export default InProgress;